import { useState } from 'react';

const faqItems = [
  {
    id: 1,
    question: 'YY漫画支持哪些阅读方式？',
    answer: 'YY漫画提供三种阅读模式：下拉式阅读（像刷社交媒体一样流畅滚动）、弹窗阅读（智能分格逐格弹出）、翻页阅读（仿真翻页动画）。你可以根据个人喜好在阅读界面随时切换，不同漫画也适合不同的阅读方式。',
  },
  {
    id: 2,
    question: 'YY漫画是完全免费的吗？',
    answer: '是的，YY漫画上的所有漫画资源都是免费阅读的。我们通过广告收入维持运营，为你提供优质且免费的漫画阅读服务。无需付费订阅，打开就能畅享海量韩漫日漫。',
  },
  {
    id: 3,
    question: '漫画更新频率是怎样的？',
    answer: '热门连载漫画基本保持与官方同步更新。韩漫通常每周更新1-2话，日漫根据连载杂志的节奏更新。你可以使用追更收藏功能，有新章节上线时会第一时间通知你。',
  },
  {
    id: 4,
    question: '支持离线下载吗？',
    answer: '支持！YY漫画APP提供离线缓存功能，你可以在WiFi环境下提前下载想看的漫画章节，之后在地铁、飞机等无网络环境中也能畅快阅读。下载的漫画会保存在本地，随时可以查阅。',
  },
  {
    id: 5,
    question: '在哪里可以下载YY漫画APP？',
    answer: 'YY漫画APP支持iOS和Android双平台。iOS用户可以在App Store搜索"YY漫画"下载，Android用户可以在官网或各大应用商店下载。APP端还支持推送通知和更流畅的阅读体验。',
  },
  {
    id: 6,
    question: '如何推荐漫画或反馈问题？',
    answer: '你可以通过本站的联系我们页面提交漫画推荐或问题反馈。如果你有特别想看的漫画作品，或者在使用过程中遇到了任何问题，欢迎随时告诉我们，YY漫画团队会认真对待每一条反馈。',
  },
];

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  return (
    <section id="faq" className="w-full py-16 md:py-22 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            关于YY漫画，你可能想了解的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
              >
                <button
                  onClick={() => setOpenId(isOpen ? null : item.id)}
                  className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <h3 className="font-bold text-sm md:text-base text-foreground-900 pr-4">
                    {item.question}
                  </h3>
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${isOpen ? 'bg-primary-100 text-primary-600' : 'bg-background-200 text-foreground-400'}`}>
                    <i className={`text-sm transition-transform duration-300 ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 ease-in-out overflow-hidden ${
                    isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}